import PropTypes from "prop-types";
import { useNavigate } from "react-router-dom";
import { Modal } from "@/config/antd";
import Button from "@/components/common/Button";
import WarningGif from "@/assets/images/veegil_loader/Warning.gif";

const Error = ({
  isVisible,
  onClose,
  header,
  paragraph,
  buttonText,
  recoveryPath,
  linkText,
  linkPath,
  handleRecovery, // Add custom handler prop
}) => {
  const navigate = useNavigate();

  // Default handler that will be used if no custom handler is provided
  const defaultRecoveryHandler = () => {
    if (recoveryPath) {
      navigate(recoveryPath);
    }
    onClose();
  };

  // Use the custom handler if provided, otherwise use the default
  const onRecoveryClick = handleRecovery || defaultRecoveryHandler;

  const handleLinkClick = () => {
    navigate(linkPath);
    onClose();
  };

  return (
    <Modal
      open={isVisible}
      onCancel={onClose}
      footer={null}
      centered
      width={350}
      styles={{
        body: { padding: 0 },
        content: {
          padding: 0,
          borderRadius: "16px",
          overflow: "hidden",
        },
        mask: { backgroundColor: "rgba(0, 0, 0, 0.75)" },
      }}
      className="custom-error-modal"
      data-testid="mock-modal">
      <div className="flex flex-col bg-white">
        <div className="p-6">
          <div className="mb-6 flex justify-center">
            <img
              src={WarningGif}
              alt="Error Icon"
              data-testid="error-icon"
              style={{
                width: "200px",
                height: "200px",
                margin: "0 auto",
                display: "block",
              }}
            />
          </div>

          <h2 className="heading-regular font-semibold text-primary mb-3 whitespace-nowrap text-center">
            {header}
          </h2>

          <p
            className="text-regular text-left text-darkGray mb-2"
            data-testid="error-paragraph">
            {paragraph}
          </p>
        </div>

        <div className="w-full bg-secondary p-4 flex flex-col items-center">
          {linkText && linkPath && (
            <button
              onClick={handleLinkClick}
              className="text-darkGray text-sm mb-3"
              data-testid="help-link">
              {linkText}
            </button>
          )}
          {buttonText && (
            <Button
              text={buttonText}
              onClick={onRecoveryClick} // Use our conditional handler
              color="primary"
              className="w-full mb-3 bg-primary text-white"
              isActive={true}
              data-testid="button-recovery-center"
            />
          )}
          <Button
            text="Cancel"
            color="primary"
            className="w-full mb-3 bg-primary border border-primary"
            onClick={onClose}
            data-testid="button-cancel"
          />
        </div>
      </div>
    </Modal>
  );
};

Error.propTypes = {
  isVisible: PropTypes.bool,
  onClose: PropTypes.func,
  header: PropTypes.string,
  paragraph: PropTypes.string,
  buttonText: PropTypes.string,
  recoveryPath: PropTypes.string,
  linkText: PropTypes.string,
  linkPath: PropTypes.string,
  handleRecovery: PropTypes.func, // Add prop type for custom handler
};

export default Error;

//  const [isAuthenticated, setIsAuthenticated] = useState(false);
//   const [isErrorVisible, setIsErrorVisible] = useState(false);
//   const [isContinueVisible, setIsContinueVisible] = useState(false);
//   const [isSecondErrorVisible, setIsSecondErrorVisible] = useState(false);  // New state for second error

//   const handleSignIn = () => {
//     setIsAuthenticated(true);
//   };

//   const handleCloseError = () => {
//     setIsErrorVisible(false);
//   };

//   const handleCloseSecondError = () => {  // New handler for second error
//     setIsSecondErrorVisible(false);
//   };

//   const handleCloseContinue = () => {
//     setIsContinueVisible(false);
//   };

// return (
//     <Router>
//       <Error
//         isVisible={isErrorVisible}
//         onClose={handleCloseError}
//         header="Account does not Exist!"
//         paragraph="The Phone Number or Email you entered does not exist in our database. Please check again to verify."
//         buttonText="Recovery Center"
//         linkText="Did you forget your Email or Phone Number?"
//         linkPath="/signup"
//         recoveryPath="/recover/password"
//         />
//       <Error
//         isVisible={isSecondErrorVisible}
//         onClose={handleCloseSecondError}
//         header="Password Incorrect"
//         paragraph="The password you entered is incorrect. Please try again or visit the recovery centerto resent the password of your Veegil SSO."
//         buttonText="Reset Password"
//         recoveryPath="/reset-password"
//     />
//   <Success
//     isVisible={isContinueVisible}
//     onClose={handleCloseContinue}
//     header="Recovery Message Sent Successfully!"
//     paragraph="Your password has been reset. Please check your email for the new password."
//     buttonText="Continue"
//     recoveryPath="/signin"
//     showCancelButton={true} // Set to true to show the cancel button
//     cancelButtonText="Close and continue later" // Customize the cancel button text
// />

//       {/* Buttons to show the errors (for testing purposes) */}
//       <button onClick={() => setIsErrorVisible(true)}>Show Account Error</button>
//       <button onClick={() => setIsSecondErrorVisible(true)}>Show Password Error</button>
//       <button onClick={() => setIsContinueVisible(true)}>Show Success</button>
//     </Router>
